export const PRIVACY_LINK_PATH = 'https://www.sparrowcard.com/legal/general-privacy-policy';
export const TERMS_OF_USE_LINK_PATH = 'https://www.sparrowcard.com/legal/terms-of-use';

export const CURRENT_YEAR = new Date().getFullYear();
